import script from "./UserOrganizationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOrganizationsTable.vue?vue&type=script&setup=true&lang=js"

import "./UserOrganizationsTable.vue?vue&type=style&index=0&id=bdb0da1c&lang=scss&scoped=true"
script.__scopeId = "data-v-bdb0da1c"

export default script